import { ORDER_DETAIL, ORDER_LIST, ORDER_UPDATE_STATUS ,ITEM_DETAIL,ADD_ITEM ,UPDATE_ITEM ,CANCEL_ITEM, CHECK_UPDATE } from './orderTypes'
import { URL_ORDER_DETAIL, URL_ORDER_LIST, URL_UPDATE_STATUS ,URL_ITEM_DETAIL ,URL_ADD_ITEM ,URL_UPDATE_ITEM ,URL_CANCEL_ITEM, URL_CHECK_UPDATE } from './orderUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

export default {
    [ORDER_LIST]({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.get(URL_ORDER_LIST, { params: item })
                .then((response) => {
                    let responseModel = new ResponseModel(response);
                    if (responseModel.status == STATUS_OK) {
                        let resultModel = responseModel.result;
                        if (resultModel.status == STATUS_OK) {
                            let data = resultModel.data;
                            commit(ORDER_LIST, data)
                            resolve(data);
                        } else {
                            commit(ORDER_LIST, { items: [], _links: {}, _meta: {} });
                            resolve({ items: [], _links: {}, _meta: {} });
                        }
                    } else {
                        commit(ORDER_LIST, { items: [], _links: {}, _meta: {} });
                        resolve({ items: [], _links: {}, _meta: {} });
                    }
                })
                .catch((error) => { reject(error); })
        })
    },

    // [ORDER_DETAIL]({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         axios.get(URL_ORDER_DETAIL, {
    //             params: params
    //         }).then((response) => {
    //             let responseModel = new ResponseModel(response);
    //             commit(ORDER_DETAIL, responseModel.result.data);
    //             resolve(responseModel.result.data);
    //         }).catch(error => reject(error));
    //     })
    // },

    [ORDER_DETAIL]({ commit }, item) {
        let param = new URLSearchParams(item).toString()
        return new Promise((resolve, reject) => {
          axios.get(`${URL_ORDER_DETAIL}${param}`)
            .then((response) => {
              let responseModel = new ResponseModel(response);
              if(responseModel.status == STATUS_OK) {
                let resultModel = responseModel.result;
                if(resultModel.status == STATUS_OK) {
                  let data = resultModel.data;
                  commit(ORDER_DETAIL, data);
                  resolve(data);
                } else {
                    reject(resultModel.message);
                }
              } else {
                reject(responseModel.message);
              }
            })
            .catch((error) => { reject(error);})
        })
    },

    // [ORDER_UPDATE_STATUS]({ commit }, data) {
    //     return new Promise((resolve, reject) => {
    //         axios.post(URL_UPDATE_STATUS, {
    //             data: data
    //         }).then((response) => {
    //             let responseModel = new ResponseModel(response);
    //             commit(ORDER_DETAIL, responseModel.result.data);
    //             resolve(responseModel.result.data);
    //         }).catch(error => reject(error));
    //     })
    // },


    [ORDER_UPDATE_STATUS]({ dispatch }, item) {
        let data = new FormData();
        for(var key in item) {
          data.append(key, item[key]);
        }
        return new Promise((resolve, reject) => {
        axios.post(`${URL_UPDATE_STATUS}`, data)
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                // commit(ORDER_DETAIL, data);
                dispatch(ORDER_LIST, {page: 1, 'per-page': item['per-page']});
                dispatch(ORDER_DETAIL, {id: item.id})
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error) });
        })
    },

    [ITEM_DETAIL]({ commit }, item) {
      let param = new URLSearchParams(item).toString()
      return new Promise((resolve, reject) => {
        axios.get(`${URL_ITEM_DETAIL}${param}`)
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                commit(ITEM_DETAIL, data);
                resolve(data);
              } else {
                  reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error);})
      })
  },

  [ADD_ITEM]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
    axios.post(`${URL_ADD_ITEM}`, item)
      .then((response) => {
        // console.log(response)
        let responseModel = new ResponseModel(response);
        if(responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if(resultModel.status == STATUS_OK) {
            let data = resultModel.data;
            dispatch(ORDER_LIST, {page: item.page, 'per-page': item['per-page']});
            dispatch(ORDER_DETAIL, {id: item.order_id})
            resolve(data);
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      })
      .catch((error) => { reject(error) });
    })
  },

  [UPDATE_ITEM]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
    axios.post(`${URL_UPDATE_ITEM}`, item)
      .then((response) => {
        // console.log(response)
        let responseModel = new ResponseModel(response);
        if(responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if(resultModel.status == STATUS_OK) {
            let data = resultModel.data;
            dispatch(ORDER_LIST, {page: item.page, 'per-page': item['per-page']});
            dispatch(ORDER_DETAIL, {id: item.order_id})
            resolve(data);
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      })
      .catch((error) => { reject(error) });
    })
  },

  [CANCEL_ITEM]({ dispatch }, item) {
    let data = new FormData();
    for(var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
    axios.post(`${URL_CANCEL_ITEM}`, data)
      .then((response) => {
        let responseModel = new ResponseModel(response);
        if(responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if(resultModel.status == STATUS_OK) {
            let data = resultModel.data;
            dispatch(ORDER_LIST, {page: item.page, 'per-page': item['per-page']});
            dispatch(ORDER_DETAIL, {id: item.order_id})
            resolve(data);
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      })
      .catch((error) => { reject(error) });
    })
  },
  [CHECK_UPDATE]({ commit, getters }) {
    return new Promise((resolve) => {
      axios.get(URL_CHECK_UPDATE)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(CHECK_UPDATE, data);
              resolve(data);
              // if (getters.lastCheckinRecord.last_checkin_active === undefined || getters.lastCheckinRecord.last_checkin_finish === undefined) {
              //   commit(CHECK_UPDATE, data);
              // } else {
              //   if (getters.lastCheckinRecord.last_checkin_active == null && data.last_checkin_active != null) {
              //     commit(CHECK_UPDATE, data);
              //     resolve(true);
              //   } else if (getters.lastCheckinRecord.last_checkin_finish == null && data.last_checkin_finish != null) {
              //     commit(CHECK_UPDATE, data);
              //     resolve(true);
              //   } else if (data.last_checkin_finish != null && data.last_checkin_finish.id != getters.lastCheckinRecord.last_checkin_finish.id) {
              //     commit(CHECK_UPDATE, data);
              //     resolve(true);
              //   } else if (data.last_checkin_active != null && data.last_checkin_active.id != getters.lastCheckinRecord.last_checkin_active.id) {
              //     commit(CHECK_UPDATE, data);
              //     resolve(true);
              //   }
              // }
            }
          }
        })
        .catch((error) => { console.log(error) });
    })
  },
}
